import { ConsoleLogger, Logger } from '@prodcard/core'

Logger.installBackend(new ConsoleLogger())
